import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import classNames from "classnames";

const prefix = "t-modal";

const Modal = ({ background, backgroundClose, children, hasCloseBtn, onCloseBtnClick, size, shown }) => {
  const [modalKey, setModalKey] = useState();

  const componentClass = classNames(
    `${prefix} ${prefix}__wrapper absolute w-screen h-screen top-0 left-0 flex flex-wrap flex-col content-center items-center justify-center`, {
      "bg-gray-400/50": background
    }
  );

  const bodyClass = classNames(`${prefix}__body relative w-auto bg-white rounded-lg shadow-md`, {
    "max-w-96 min-w-96": size === "sm",
    "max-w-[600px] min-w-[600px]": size === undefined || size === "md",
    "lg:min-w-[800px]": size === "lg",
    "xl:min-w-[100px]": size === "xl"
  });

  const close = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (typeof onCloseBtnClick === "function") onCloseBtnClick();
  }

  useEffect(() => {
    if (shown) setModalKey(parseInt(Date.now(), 16));
  }, [shown]);

  if (shown !== true) return null;

  return createPortal(
    <div className={componentClass} data-modal-key={modalKey} onClick={(e) => {if (backgroundClose) close(e);}}>
      <div className={bodyClass} onClick={(e) => e.stopPropagation()}>
        <div className={`${prefix}__header min-h-10 shadow px-4 py-2 flex flex-wrap items-center`}>
          <span className="--title text-lg">Modal</span>
          {hasCloseBtn && <span
            className="--times absolute right-3 text-3xl cursor-pointer hover:bg-gray-200/50 px-2"
            onClick={close}
          >&times;</span>}
        </div>
        <div className={`${prefix}__content min-h-24 px-4 py-2`}>
          {children}
        </div>
        <div className={`${prefix}__footer min-h-12 px-4 py-2`}></div>
      </div>
    </div>
  , document.getElementById("root"));
};

Modal.propTypes = {
  background: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  backgroundClose: PropTypes.bool,
  hasCloseBtn: PropTypes.bool,
  onCloseBtnClick: PropTypes.func,
  size: PropTypes.oneOf(["sm", "md", "lg"])
};

Modal.defaultProps = {
  background: true,
  backgroundClose: true,
  hasCloseBtn: true,
  onCloseBtnClick: () => {},
  size: "md"
};

export default Modal;
